import axios from "axios";
import React, { useEffect, useState } from "react";
import { getAuthUser } from "../Authentication/authHelper";
import { mainServerAppUrl } from "../../apis/mainApi";
import { SideMenu } from "../Side-Menu/sideMenu";
import { toast } from "react-hot-toast";

export const PatronPayment = () => {
  const [patronId, setPatronId] = useState(getAuthUser().membership_no);
  const [orderDetails, setOrderDetails] = useState([]);
  
  useEffect(() => {
    window.scrollTo(0, 0);
    toast.dismiss();
  }, []);

  useEffect(() => {
    axios
      .get(mainServerAppUrl + `/user/patron/order-payment/${patronId}`)
      .then((result) => {
        // console.log(result.data);
        setOrderDetails(result.data.orderPayment);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, []);

  const handlePayment = (order) => {
    // console.log(order)
    axios
      .post(mainServerAppUrl + "/patron/create-checkout-session", order)
      .then((result) => {
        console.log(result.data, "ser1");
        let url = ""; 
        url = result.data.url;
        toast.success(result.data.message, { id: "success", duration: 2500 });
        setTimeout(() => {
          window.open(url, "_self");
        }, 3000);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.message, {
          id: "error",
          duration: 3000,
        });
      });
      console.log("order_status:", order.order_status);
  };


  return (
    <div className="max-resolution">
      <header>
        
        <div className="header-info">
          <div className="left-part">
            <a href="/patron-home" className="site-logo">
              <img src={require("../../assets/images/thcm-logo-red.png")} />
            </a>
          </div>
          <div className="right-part">
            <h1>Homey-FOODS</h1>
            <p>
              Throughout human history in all cultures food is an important
              basis of social bonding. With our increasing human family
              worldwide. Homey-FOODS offering a venue for all to enjoy unique
              cuisines, healthy regional foods by many who enjoy cooking and
              eager to serve variety of foods.{" "}
            </p>
            <p>
              <span>
                “Restaurant Meals can increase cardiovascular disease
                risk”Journal of the Academy of Nutrition and Dietetics-March
                2021
              </span>
            </p>
          </div>
        </div>
      </header>
      <main>
        <div className="home-section-1 position-relative">
          {/* <SideMenu /> */}
          <h2>Easy and Fast Access to Homey-FOODS</h2>
          <span className="text_msg">PATRONS- PAYMENTS</span>
        </div>
        {orderDetails.length === 0 ? (
          <div className="col-12 not_found">
            <p>Seems like you have not placed any orders yet!</p>
          </div>
        ) : (
          <div className="meal_history_section centered pb-4">
            {orderDetails.map((order, ind) => (
              <div key={ind}>
                <div
                  className="meal_history_box"
                  style={{ marginBottom: "0px" }}
                >
                  <div className="meal_host_name pb-2">
                    <span className="label">Meal - {order.meal_name}</span>
                  </div>
                  <div className="meal_host_name pb-2">
                    <span className="label">Type - {order.meal_type}</span>
                  </div>
                  <div className="meal_host_date pb-2">
                    <span className="label">
                      Order Status - {order.order_status}
                    </span>
                  </div>
                  <div className="meal_host_date pb-2">
                    <span className="label">
                      Order Quantity - {order.order_quantity}
                    </span>
                  </div>
                  <div className="meal_host_date pb-2">
                    <span className="label">
                      Payment Status - {order.payment_status}
                    </span>
                  </div>
                  <div className="meal_host_price pb-2">
                    <span className="label">
                      Total - ${order.price * order.order_quantity}
                    </span>
                  </div>
                  {order.order_status === "processing" && (
                    <div>
                      <span style={{ fontSize: "15px", color: "maroon" }}>
                        Note - You can pay for your order, after it has been
                        accepted.
                      </span>
                    </div>
                    
                  )}
                </div>
                <div className="col-12 p-2">
                  <button
                    className="btn w-100"
                    disabled={order.order_status === "confirmed" ? false : true}
                    // disabled={order.order_status === "processing" ? false : true}

                    onClick={() => handlePayment(order)}
                  >
                    CLICK TO PAY
                  </button> 
                </div>

                <br />
              </div>
            ))}
          </div>
        )}
      </main>
      <footer>
        <div className="footer-content">
          <div className="disclaimer">
            <p className="pb-2">Disclaimer</p>
          </div>
          <p>
            Homey-FOODS is a service that brings Meal Hosts and Patrons
            together. Homey-FOODS makes no representations, endorsements. or
            warranties of any kind whatsoever of Meal Hosts and Customers. Both
            parties agree to comply to local government laws, be of legal age
            and Homey-FOODS shall not be held responsible from disputes, damages
            and controversies.
          </p>
        </div>
        <div className="footer_bottom">
          <a href="https://www.homey-foods.com" className="site_link">
            www.homey-foods.com
          </a>
          <div className="social-media">
            <ul>
              <li>
                <a href="#" target="_blank">
                  <i className="fab fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a href="#" target="_blank">
                  <i className="fab fa-twitter"></i>
                </a>
              </li>
              <li>
                <a href="#" target="_blank">
                  <i className="fab fa-linkedin"></i>{" "}
                </a>
              </li>
              <li>
                <a href="#" target="_blank">
                  <i className="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
          <p>© 2023 Homey-FOODS</p>
        </div>
      </footer>
    </div>
  );
};
